// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UNCHECKED_CAST", "UNUSED_PARAMETER", "UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.ast.CallInfo
import io.peekandpoke.klang.script.builder.*
import io.peekandpoke.klang.script.runtime.*
import io.peekandpoke.klang.script.types.*

import io.peekandpoke.klang.audio_bridge.KatalystDsl
import io.peekandpoke.klang.script.runtime.ObjectValue
import io.peekandpoke.klang.script.runtime.StringValue
import io.peekandpoke.klang.script.stdlib.IgnitorSlotLike
import io.peekandpoke.klang.script.stdlib.KatalystSlotLike
import io.peekandpoke.klang.sprudel.SprudelPattern
import io.peekandpoke.klang.sprudel.lang.PatternLike
import io.peekandpoke.klang.sprudel.lang.PatternMapperFn
import io.peekandpoke.klang.sprudel.lang.PatternMapperProvider
import io.peekandpoke.klang.sprudel.lang.abs
import io.peekandpoke.klang.sprudel.lang.accelerate
import io.peekandpoke.klang.sprudel.lang.add
import io.peekandpoke.klang.sprudel.lang.adsr
import io.peekandpoke.klang.sprudel.lang.adsrCurves
import io.peekandpoke.klang.sprudel.lang.adsrOff
import io.peekandpoke.klang.sprudel.lang.adsrOn
import io.peekandpoke.klang.sprudel.lang.almostAlways
import io.peekandpoke.klang.sprudel.lang.almostNever
import io.peekandpoke.klang.sprudel.lang.always
import io.peekandpoke.klang.sprudel.lang.analog
import io.peekandpoke.klang.sprudel.lang.and
import io.peekandpoke.klang.sprudel.lang.apply
import io.peekandpoke.klang.sprudel.lang.applyN
import io.peekandpoke.klang.sprudel.lang.arrange
import io.peekandpoke.klang.sprudel.lang.bandpass
import io.peekandpoke.klang.sprudel.lang.bank
import io.peekandpoke.klang.sprudel.lang.beatRate
import io.peekandpoke.klang.sprudel.lang.beats
import io.peekandpoke.klang.sprudel.lang.begin
import io.peekandpoke.klang.sprudel.lang.berlin
import io.peekandpoke.klang.sprudel.lang.binary
import io.peekandpoke.klang.sprudel.lang.binaryL
import io.peekandpoke.klang.sprudel.lang.binaryN
import io.peekandpoke.klang.sprudel.lang.binaryNL
import io.peekandpoke.klang.sprudel.lang.bitAnd
import io.peekandpoke.klang.sprudel.lang.bitOr
import io.peekandpoke.klang.sprudel.lang.bitShl
import io.peekandpoke.klang.sprudel.lang.bitShr
import io.peekandpoke.klang.sprudel.lang.bitXor
import io.peekandpoke.klang.sprudel.lang.bite
import io.peekandpoke.klang.sprudel.lang.bjork
import io.peekandpoke.klang.sprudel.lang.body
import io.peekandpoke.klang.sprudel.lang.bpf
import io.peekandpoke.klang.sprudel.lang.bpfCurves
import io.peekandpoke.klang.sprudel.lang.bpm
import io.peekandpoke.klang.sprudel.lang.brak
import io.peekandpoke.klang.sprudel.lang.brand
import io.peekandpoke.klang.sprudel.lang.brandBy
import io.peekandpoke.klang.sprudel.lang.bypass
import io.peekandpoke.klang.sprudel.lang.cat
import io.peekandpoke.klang.sprudel.lang.ceil
import io.peekandpoke.klang.sprudel.lang.choose
import io.peekandpoke.klang.sprudel.lang.chooseCycles
import io.peekandpoke.klang.sprudel.lang.chooseIn
import io.peekandpoke.klang.sprudel.lang.chooseInWith
import io.peekandpoke.klang.sprudel.lang.chooseOut
import io.peekandpoke.klang.sprudel.lang.chooseWith
import io.peekandpoke.klang.sprudel.lang.chord
import io.peekandpoke.klang.sprudel.lang.chunk
import io.peekandpoke.klang.sprudel.lang.chunkBack
import io.peekandpoke.klang.sprudel.lang.chunkBackInto
import io.peekandpoke.klang.sprudel.lang.chunkInto
import io.peekandpoke.klang.sprudel.lang.chunkback
import io.peekandpoke.klang.sprudel.lang.chunkbackinto
import io.peekandpoke.klang.sprudel.lang.chunkinto
import io.peekandpoke.klang.sprudel.lang.clamp
import io.peekandpoke.klang.sprudel.lang.clip
import io.peekandpoke.klang.sprudel.lang.coarse
import io.peekandpoke.klang.sprudel.lang.comp
import io.peekandpoke.klang.sprudel.lang.compress
import io.peekandpoke.klang.sprudel.lang.compressor
import io.peekandpoke.klang.sprudel.lang.cosine
import io.peekandpoke.klang.sprudel.lang.cps
import io.peekandpoke.klang.sprudel.lang.crush
import io.peekandpoke.klang.sprudel.lang.cull
import io.peekandpoke.klang.sprudel.lang.cut
import io.peekandpoke.klang.sprudel.lang.cylinder
import io.peekandpoke.klang.sprudel.lang.d
import io.peekandpoke.klang.sprudel.lang.degrade
import io.peekandpoke.klang.sprudel.lang.degradeBy
import io.peekandpoke.klang.sprudel.lang.degradeByWith
import io.peekandpoke.klang.sprudel.lang.delay
import io.peekandpoke.klang.sprudel.lang.density
import io.peekandpoke.klang.sprudel.lang.densityGap
import io.peekandpoke.klang.sprudel.lang.distort
import io.peekandpoke.klang.sprudel.lang.div
import io.peekandpoke.klang.sprudel.lang.drop
import io.peekandpoke.klang.sprudel.lang.duck
import io.peekandpoke.klang.sprudel.lang.duty
import io.peekandpoke.klang.sprudel.lang.early
import io.peekandpoke.klang.sprudel.lang.earlyInCycle
import io.peekandpoke.klang.sprudel.lang.echo
import io.peekandpoke.klang.sprudel.lang.echoWith
import io.peekandpoke.klang.sprudel.lang.echowith
import io.peekandpoke.klang.sprudel.lang.eish
import io.peekandpoke.klang.sprudel.lang.end
import io.peekandpoke.klang.sprudel.lang.eq
import io.peekandpoke.klang.sprudel.lang.eqt
import io.peekandpoke.klang.sprudel.lang.euclid
import io.peekandpoke.klang.sprudel.lang.euclidLegato
import io.peekandpoke.klang.sprudel.lang.euclidLegatoRot
import io.peekandpoke.klang.sprudel.lang.euclidRot
import io.peekandpoke.klang.sprudel.lang.euclidish
import io.peekandpoke.klang.sprudel.lang.euclidrot
import io.peekandpoke.klang.sprudel.lang.every
import io.peekandpoke.klang.sprudel.lang.extend
import io.peekandpoke.klang.sprudel.lang.fast
import io.peekandpoke.klang.sprudel.lang.fastChunk
import io.peekandpoke.klang.sprudel.lang.fastGap
import io.peekandpoke.klang.sprudel.lang.fastcat
import io.peekandpoke.klang.sprudel.lang.fastchunk
import io.peekandpoke.klang.sprudel.lang.filterWhen
import io.peekandpoke.klang.sprudel.lang.firstOf
import io.peekandpoke.klang.sprudel.lang.flipSign
import io.peekandpoke.klang.sprudel.lang.floor
import io.peekandpoke.klang.sprudel.lang.fm
import io.peekandpoke.klang.sprudel.lang.focus
import io.peekandpoke.klang.sprudel.lang.freq
import io.peekandpoke.klang.sprudel.lang.gain
import io.peekandpoke.klang.sprudel.lang.gap
import io.peekandpoke.klang.sprudel.lang.gt
import io.peekandpoke.klang.sprudel.lang.gte
import io.peekandpoke.klang.sprudel.lang.highpass
import io.peekandpoke.klang.sprudel.lang.hpf
import io.peekandpoke.klang.sprudel.lang.hpfCurves
import io.peekandpoke.klang.sprudel.lang.hurry
import io.peekandpoke.klang.sprudel.lang.hush
import io.peekandpoke.klang.sprudel.lang.ignitorParam
import io.peekandpoke.klang.sprudel.lang.ignp
import io.peekandpoke.klang.sprudel.lang.inhabit
import io.peekandpoke.klang.sprudel.lang.inhabitmod
import io.peekandpoke.klang.sprudel.lang.inside
import io.peekandpoke.klang.sprudel.lang.inv
import io.peekandpoke.klang.sprudel.lang.invert
import io.peekandpoke.klang.sprudel.lang.irand
import io.peekandpoke.klang.sprudel.lang.iter
import io.peekandpoke.klang.sprudel.lang.iterBack
import io.peekandpoke.klang.sprudel.lang.jux
import io.peekandpoke.klang.sprudel.lang.juxBy
import io.peekandpoke.klang.sprudel.lang.katalyst
import io.peekandpoke.klang.sprudel.lang.katalystParam
import io.peekandpoke.klang.sprudel.lang.katp
import io.peekandpoke.klang.sprudel.lang.lastOf
import io.peekandpoke.klang.sprudel.lang.late
import io.peekandpoke.klang.sprudel.lang.lateInCycle
import io.peekandpoke.klang.sprudel.lang.layer
import io.peekandpoke.klang.sprudel.lang.legato
import io.peekandpoke.klang.sprudel.lang.linger
import io.peekandpoke.klang.sprudel.lang.log2
import io.peekandpoke.klang.sprudel.lang.loop
import io.peekandpoke.klang.sprudel.lang.loopAt
import io.peekandpoke.klang.sprudel.lang.loopAtCps
import io.peekandpoke.klang.sprudel.lang.loopatcps
import io.peekandpoke.klang.sprudel.lang.lowpass
import io.peekandpoke.klang.sprudel.lang.lpf
import io.peekandpoke.klang.sprudel.lang.lpfCurves
import io.peekandpoke.klang.sprudel.lang.lt
import io.peekandpoke.klang.sprudel.lang.lte
import io.peekandpoke.klang.sprudel.lang.mask
import io.peekandpoke.klang.sprudel.lang.maskAll
import io.peekandpoke.klang.sprudel.lang.master
import io.peekandpoke.klang.sprudel.lang.max
import io.peekandpoke.klang.sprudel.lang.merge
import io.peekandpoke.klang.sprudel.lang.min
import io.peekandpoke.klang.sprudel.lang.mini
import io.peekandpoke.klang.sprudel.lang.mod
import io.peekandpoke.klang.sprudel.lang.morse
import io.peekandpoke.klang.sprudel.lang.mul
import io.peekandpoke.klang.sprudel.lang.mute
import io.peekandpoke.klang.sprudel.lang.n
import io.peekandpoke.klang.sprudel.lang.ne
import io.peekandpoke.klang.sprudel.lang.net
import io.peekandpoke.klang.sprudel.lang.never
import io.peekandpoke.klang.sprudel.lang.noCull
import io.peekandpoke.klang.sprudel.lang.not
import io.peekandpoke.klang.sprudel.lang.notch
import io.peekandpoke.klang.sprudel.lang.notchCurves
import io.peekandpoke.klang.sprudel.lang.note
import io.peekandpoke.klang.sprudel.lang.nothing
import io.peekandpoke.klang.sprudel.lang.o
import io.peekandpoke.klang.sprudel.lang.off
import io.peekandpoke.klang.sprudel.lang.often
import io.peekandpoke.klang.sprudel.lang.oneMinusValue
import io.peekandpoke.klang.sprudel.lang.onepole
import io.peekandpoke.klang.sprudel.lang.or
import io.peekandpoke.klang.sprudel.lang.orbit
import io.peekandpoke.klang.sprudel.lang.outside
import io.peekandpoke.klang.sprudel.lang.pace
import io.peekandpoke.klang.sprudel.lang.palindrome
import io.peekandpoke.klang.sprudel.lang.pan
import io.peekandpoke.klang.sprudel.lang.penv
import io.peekandpoke.klang.sprudel.lang.penvCurves
import io.peekandpoke.klang.sprudel.lang.perlin
import io.peekandpoke.klang.sprudel.lang.phaser
import io.peekandpoke.klang.sprudel.lang.pick
import io.peekandpoke.klang.sprudel.lang.pickF
import io.peekandpoke.klang.sprudel.lang.pickOut
import io.peekandpoke.klang.sprudel.lang.pickReset
import io.peekandpoke.klang.sprudel.lang.pickRestart
import io.peekandpoke.klang.sprudel.lang.pickSqueeze
import io.peekandpoke.klang.sprudel.lang.pickmod
import io.peekandpoke.klang.sprudel.lang.pickmodF
import io.peekandpoke.klang.sprudel.lang.pickmodOut
import io.peekandpoke.klang.sprudel.lang.pickmodReset
import io.peekandpoke.klang.sprudel.lang.pickmodRestart
import io.peekandpoke.klang.sprudel.lang.pickmodSqueeze
import io.peekandpoke.klang.sprudel.lang.ply
import io.peekandpoke.klang.sprudel.lang.plyForEach
import io.peekandpoke.klang.sprudel.lang.plyWith
import io.peekandpoke.klang.sprudel.lang.plyforeach
import io.peekandpoke.klang.sprudel.lang.plywith
import io.peekandpoke.klang.sprudel.lang.polymeter
import io.peekandpoke.klang.sprudel.lang.polymeterSteps
import io.peekandpoke.klang.sprudel.lang.polyrhythm
import io.peekandpoke.klang.sprudel.lang.pow
import io.peekandpoke.klang.sprudel.lang.pregain
import io.peekandpoke.klang.sprudel.lang.press
import io.peekandpoke.klang.sprudel.lang.pressBy
import io.peekandpoke.klang.sprudel.lang.pure
import io.peekandpoke.klang.sprudel.lang.rand
import io.peekandpoke.klang.sprudel.lang.randCycle
import io.peekandpoke.klang.sprudel.lang.randcat
import io.peekandpoke.klang.sprudel.lang.randrun
import io.peekandpoke.klang.sprudel.lang.range
import io.peekandpoke.klang.sprudel.lang.rangex
import io.peekandpoke.klang.sprudel.lang.rarely
import io.peekandpoke.klang.sprudel.lang.ratio
import io.peekandpoke.klang.sprudel.lang.repeat
import io.peekandpoke.klang.sprudel.lang.repeatCycles
import io.peekandpoke.klang.sprudel.lang.rest
import io.peekandpoke.klang.sprudel.lang.rev
import io.peekandpoke.klang.sprudel.lang.reverb
import io.peekandpoke.klang.sprudel.lang.revv
import io.peekandpoke.klang.sprudel.lang.rib
import io.peekandpoke.klang.sprudel.lang.ribbon
import io.peekandpoke.klang.sprudel.lang.rootNotes
import io.peekandpoke.klang.sprudel.lang.round
import io.peekandpoke.klang.sprudel.lang.rpm
import io.peekandpoke.klang.sprudel.lang.run
import io.peekandpoke.klang.sprudel.lang.s
import io.peekandpoke.klang.sprudel.lang.s_cat
import io.peekandpoke.klang.sprudel.lang.saw
import io.peekandpoke.klang.sprudel.lang.scale
import io.peekandpoke.klang.sprudel.lang.scaleTranspose
import io.peekandpoke.klang.sprudel.lang.scramble
import io.peekandpoke.klang.sprudel.lang.seed
import io.peekandpoke.klang.sprudel.lang.seg
import io.peekandpoke.klang.sprudel.lang.segment
import io.peekandpoke.klang.sprudel.lang.seq
import io.peekandpoke.klang.sprudel.lang.sequenceP
import io.peekandpoke.klang.sprudel.lang.shuffle
import io.peekandpoke.klang.sprudel.lang.signal
import io.peekandpoke.klang.sprudel.lang.silence
import io.peekandpoke.klang.sprudel.lang.sine
import io.peekandpoke.klang.sprudel.lang.sineOfDay
import io.peekandpoke.klang.sprudel.lang.sineOfNight
import io.peekandpoke.klang.sprudel.lang.slice
import io.peekandpoke.klang.sprudel.lang.slow
import io.peekandpoke.klang.sprudel.lang.slowChunk
import io.peekandpoke.klang.sprudel.lang.slowcat
import io.peekandpoke.klang.sprudel.lang.slowcatPrime
import io.peekandpoke.klang.sprudel.lang.slowchunk
import io.peekandpoke.klang.sprudel.lang.sndBrown
import io.peekandpoke.klang.sprudel.lang.sndCrackle
import io.peekandpoke.klang.sprudel.lang.sndDust
import io.peekandpoke.klang.sprudel.lang.sndNoise
import io.peekandpoke.klang.sprudel.lang.sndPink
import io.peekandpoke.klang.sprudel.lang.sndPluck
import io.peekandpoke.klang.sprudel.lang.sndPulze
import io.peekandpoke.klang.sprudel.lang.sndRamp
import io.peekandpoke.klang.sprudel.lang.sndSaw
import io.peekandpoke.klang.sprudel.lang.sndSine
import io.peekandpoke.klang.sprudel.lang.sndSquare
import io.peekandpoke.klang.sprudel.lang.sndSuperPluck
import io.peekandpoke.klang.sprudel.lang.sndSuperRamp
import io.peekandpoke.klang.sprudel.lang.sndSuperSaw
import io.peekandpoke.klang.sprudel.lang.sndSuperSine
import io.peekandpoke.klang.sprudel.lang.sndSuperSquare
import io.peekandpoke.klang.sprudel.lang.sndSuperTri
import io.peekandpoke.klang.sprudel.lang.sndTri
import io.peekandpoke.klang.sprudel.lang.sndZamp
import io.peekandpoke.klang.sprudel.lang.solo
import io.peekandpoke.klang.sprudel.lang.someCycles
import io.peekandpoke.klang.sprudel.lang.someCyclesBy
import io.peekandpoke.klang.sprudel.lang.sometimes
import io.peekandpoke.klang.sprudel.lang.sometimesBy
import io.peekandpoke.klang.sprudel.lang.sound
import io.peekandpoke.klang.sprudel.lang.speed
import io.peekandpoke.klang.sprudel.lang.splice
import io.peekandpoke.klang.sprudel.lang.square
import io.peekandpoke.klang.sprudel.lang.squeeze
import io.peekandpoke.klang.sprudel.lang.stack
import io.peekandpoke.klang.sprudel.lang.stackBy
import io.peekandpoke.klang.sprudel.lang.stackCentre
import io.peekandpoke.klang.sprudel.lang.stackLeft
import io.peekandpoke.klang.sprudel.lang.stackRight
import io.peekandpoke.klang.sprudel.lang.steady
import io.peekandpoke.klang.sprudel.lang.stepcat
import io.peekandpoke.klang.sprudel.lang.steps
import io.peekandpoke.klang.sprudel.lang.stretchBy
import io.peekandpoke.klang.sprudel.lang.struct
import io.peekandpoke.klang.sprudel.lang.structAll
import io.peekandpoke.klang.sprudel.lang.stut
import io.peekandpoke.klang.sprudel.lang.stutWith
import io.peekandpoke.klang.sprudel.lang.stutwith
import io.peekandpoke.klang.sprudel.lang.sub
import io.peekandpoke.klang.sprudel.lang.superimpose
import io.peekandpoke.klang.sprudel.lang.swing
import io.peekandpoke.klang.sprudel.lang.swingBy
import io.peekandpoke.klang.sprudel.lang.tag
import io.peekandpoke.klang.sprudel.lang.take
import io.peekandpoke.klang.sprudel.lang.time
import io.peekandpoke.klang.sprudel.lang.timeCat
import io.peekandpoke.klang.sprudel.lang.timeLoop
import io.peekandpoke.klang.sprudel.lang.timeOfDay
import io.peekandpoke.klang.sprudel.lang.timeOfNight
import io.peekandpoke.klang.sprudel.lang.timecat
import io.peekandpoke.klang.sprudel.lang.transpose
import io.peekandpoke.klang.sprudel.lang.tremolo
import io.peekandpoke.klang.sprudel.lang.tri
import io.peekandpoke.klang.sprudel.lang.tweak
import io.peekandpoke.klang.sprudel.lang.tweaks
import io.peekandpoke.klang.sprudel.lang.undegrade
import io.peekandpoke.klang.sprudel.lang.undegradeBy
import io.peekandpoke.klang.sprudel.lang.undegradeByWith
import io.peekandpoke.klang.sprudel.lang.uni
import io.peekandpoke.klang.sprudel.lang.unison
import io.peekandpoke.klang.sprudel.lang.unit
import io.peekandpoke.klang.sprudel.lang.vel
import io.peekandpoke.klang.sprudel.lang.velocity
import io.peekandpoke.klang.sprudel.lang.vib
import io.peekandpoke.klang.sprudel.lang.vibrato
import io.peekandpoke.klang.sprudel.lang.voicing
import io.peekandpoke.klang.sprudel.lang.vowel
import io.peekandpoke.klang.sprudel.lang.wchoose
import io.peekandpoke.klang.sprudel.lang.wchooseCycles
import io.peekandpoke.klang.sprudel.lang.`when`
import io.peekandpoke.klang.sprudel.lang.withSeed
import io.peekandpoke.klang.sprudel.lang.within
import io.peekandpoke.klang.sprudel.lang.wrandcat
import io.peekandpoke.klang.sprudel.lang.zoom
import kotlin.Function1

internal fun KlangScriptExtensionBuilder.registerSprudelLangStructuralChunk0() {

    // @Function on stepcat
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("stepcat") { args, callInfo -> stepcat(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "stepcat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "stepcat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.stepcat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "stepcat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "stepcat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.stepcat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on timeCat
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("timeCat") { args, callInfo -> timeCat(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "timeCat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "timeCat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.timeCat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "timeCat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "timeCat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.timeCat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on timecat
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("timecat") { args, callInfo -> timecat(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "timecat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "timecat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.timecat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "timecat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "timecat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.timecat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on s_cat
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("s_cat") { args, callInfo -> s_cat(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "s_cat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "s_cat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.s_cat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "s_cat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "s_cat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.s_cat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on polyrhythm
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("polyrhythm") { args, callInfo -> polyrhythm(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "polyrhythm",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "polyrhythm", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.polyrhythm(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "polyrhythm",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "polyrhythm", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.polyrhythm(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on cat
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("cat") { args, callInfo -> cat(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "cat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "cat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.cat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "cat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "cat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.cat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on fastcat
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("fastcat") { args, callInfo -> fastcat(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "fastcat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "fastcat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.fastcat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "fastcat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "fastcat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.fastcat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on slowcat
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("slowcat") { args, callInfo -> slowcat(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "slowcat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "slowcat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.slowcat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "slowcat",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "slowcat", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.slowcat(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on slowcatPrime
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("slowcatPrime") { args, callInfo -> slowcatPrime(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "slowcatPrime",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "slowcatPrime", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.slowcatPrime(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "slowcatPrime",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "slowcatPrime", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.slowcatPrime(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on polymeter
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("polymeter") { args, callInfo -> polymeter(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "polymeter",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "polymeter", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.polymeter(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "polymeter",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "polymeter", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.polymeter(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on polymeterSteps
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("polymeterSteps") { args, callInfo -> polymeterSteps(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "chunk",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class),
            ParamSpec(name = "back", kotlinType = Boolean::class, isOptional = true, default = { wrapAsRuntimeValue(false) }),
            ParamSpec(name = "fast", kotlinType = Boolean::class, isOptional = true, default = { wrapAsRuntimeValue(false) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunk", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunk", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunk", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(
            typedReceiver.chunk(
                n = n,
                transform = transform,
                back = if (args.size > 2) convertArgToKotlin(fn = "chunk", args = args, index = 2, cls = Boolean::class, nullable = false, loc = loc) as Boolean else false,
                fast = if (args.size > 3) convertArgToKotlin(fn = "chunk", args = args, index = 3, cls = Boolean::class, nullable = false, loc = loc) as Boolean else false,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "chunk",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class),
            ParamSpec(name = "back", kotlinType = Boolean::class, isOptional = true, default = { wrapAsRuntimeValue(false) }),
            ParamSpec(name = "fast", kotlinType = Boolean::class, isOptional = true, default = { wrapAsRuntimeValue(false) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunk", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunk", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunk", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(
            typedReceiver.chunk(
                n = n,
                transform = transform,
                back = if (args.size > 2) convertArgToKotlin(fn = "chunk", args = args, index = 2, cls = Boolean::class, nullable = false, loc = loc) as Boolean else false,
                fast = if (args.size > 3) convertArgToKotlin(fn = "chunk", args = args, index = 3, cls = Boolean::class, nullable = false, loc = loc) as Boolean else false,
                callInfo = callInfo,
            )
        )
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangStructuralChunk1() {

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "slowchunk",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class),
            ParamSpec(name = "back", kotlinType = Boolean::class, isOptional = true, default = { wrapAsRuntimeValue(false) }),
            ParamSpec(name = "fast", kotlinType = Boolean::class, isOptional = true, default = { wrapAsRuntimeValue(false) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "slowchunk", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "slowchunk", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "slowchunk", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(
            typedReceiver.slowchunk(
                n = n,
                transform = transform,
                back = if (args.size > 2) convertArgToKotlin(fn = "slowchunk", args = args, index = 2, cls = Boolean::class, nullable = false, loc = loc) as Boolean else false,
                fast = if (args.size > 3) convertArgToKotlin(fn = "slowchunk", args = args, index = 3, cls = Boolean::class, nullable = false, loc = loc) as Boolean else false,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "slowchunk",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class),
            ParamSpec(name = "back", kotlinType = Boolean::class, isOptional = true, default = { wrapAsRuntimeValue(false) }),
            ParamSpec(name = "fast", kotlinType = Boolean::class, isOptional = true, default = { wrapAsRuntimeValue(false) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "slowchunk", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "slowchunk", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "slowchunk", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(
            typedReceiver.slowchunk(
                n = n,
                transform = transform,
                back = if (args.size > 2) convertArgToKotlin(fn = "slowchunk", args = args, index = 2, cls = Boolean::class, nullable = false, loc = loc) as Boolean else false,
                fast = if (args.size > 3) convertArgToKotlin(fn = "slowchunk", args = args, index = 3, cls = Boolean::class, nullable = false, loc = loc) as Boolean else false,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "slowChunk",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class),
            ParamSpec(name = "back", kotlinType = Boolean::class, isOptional = true, default = { wrapAsRuntimeValue(false) }),
            ParamSpec(name = "fast", kotlinType = Boolean::class, isOptional = true, default = { wrapAsRuntimeValue(false) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "slowChunk", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "slowChunk", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "slowChunk", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(
            typedReceiver.slowChunk(
                n = n,
                transform = transform,
                back = if (args.size > 2) convertArgToKotlin(fn = "slowChunk", args = args, index = 2, cls = Boolean::class, nullable = false, loc = loc) as Boolean else false,
                fast = if (args.size > 3) convertArgToKotlin(fn = "slowChunk", args = args, index = 3, cls = Boolean::class, nullable = false, loc = loc) as Boolean else false,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "slowChunk",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class),
            ParamSpec(name = "back", kotlinType = Boolean::class, isOptional = true, default = { wrapAsRuntimeValue(false) }),
            ParamSpec(name = "fast", kotlinType = Boolean::class, isOptional = true, default = { wrapAsRuntimeValue(false) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "slowChunk", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "slowChunk", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "slowChunk", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(
            typedReceiver.slowChunk(
                n = n,
                transform = transform,
                back = if (args.size > 2) convertArgToKotlin(fn = "slowChunk", args = args, index = 2, cls = Boolean::class, nullable = false, loc = loc) as Boolean else false,
                fast = if (args.size > 3) convertArgToKotlin(fn = "slowChunk", args = args, index = 3, cls = Boolean::class, nullable = false, loc = loc) as Boolean else false,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "chunkBack",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunkBack", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunkBack", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunkBack", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.chunkBack(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "chunkBack",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunkBack", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunkBack", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunkBack", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.chunkBack(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "chunkback",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunkback", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunkback", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunkback", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.chunkback(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "chunkback",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunkback", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunkback", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunkback", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.chunkback(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "fastChunk",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "fastChunk", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "fastChunk", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "fastChunk", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.fastChunk(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "fastChunk",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "fastChunk", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "fastChunk", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "fastChunk", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.fastChunk(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "fastchunk",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "fastchunk", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "fastchunk", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "fastchunk", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.fastchunk(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "fastchunk",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "fastchunk", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "fastchunk", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "fastchunk", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.fastchunk(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "chunkInto",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunkInto", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunkInto", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunkInto", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.chunkInto(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "chunkInto",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunkInto", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunkInto", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunkInto", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.chunkInto(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "chunkinto",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunkinto", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunkinto", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunkinto", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.chunkinto(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "chunkinto",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunkinto", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunkinto", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunkinto", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.chunkinto(n = n, transform = transform, callInfo = callInfo))
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangStructuralChunk2() {

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "chunkBackInto",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunkBackInto", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunkBackInto", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunkBackInto", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.chunkBackInto(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "chunkBackInto",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunkBackInto", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunkBackInto", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunkBackInto", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.chunkBackInto(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "chunkbackinto",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunkbackinto", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunkbackinto", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunkbackinto", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.chunkbackinto(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "chunkbackinto",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "chunkbackinto", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "chunkbackinto", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val transform = convertArgToKotlin(fn = "chunkbackinto", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.chunkbackinto(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "echo",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "decay", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "echo", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "echo", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "echo", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val decay = convertArgToKotlin(fn = "echo", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.echo(times = times, delay = delay, decay = decay, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "echo",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "decay", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "echo", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "echo", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "echo", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val decay = convertArgToKotlin(fn = "echo", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.echo(times = times, delay = delay, decay = decay, callInfo = callInfo))
    }

    // @Function on echo
    registerFunctionWithSpecs(
        name = "echo",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "decay", kotlinType = Double::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "echo", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "echo", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "echo", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val decay = convertArgToKotlin(fn = "echo", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(echo(times = times, delay = delay, decay = decay, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "echo",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "decay", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "echo", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "echo", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "echo", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val decay = convertArgToKotlin(fn = "echo", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.echo(times = times, delay = delay, decay = decay, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "stut",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "decay", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "stut", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "stut", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "stut", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val decay = convertArgToKotlin(fn = "stut", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.stut(times = times, delay = delay, decay = decay, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "stut",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "decay", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "stut", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "stut", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "stut", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val decay = convertArgToKotlin(fn = "stut", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.stut(times = times, delay = delay, decay = decay, callInfo = callInfo))
    }

    // @Function on stut
    registerFunctionWithSpecs(
        name = "stut",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "decay", kotlinType = Double::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "stut", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "stut", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "stut", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val decay = convertArgToKotlin(fn = "stut", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(stut(times = times, delay = delay, decay = decay, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "stut",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "decay", kotlinType = Double::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "stut", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "stut", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "stut", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val decay = convertArgToKotlin(fn = "stut", args = args, index = 2, cls = Double::class, nullable = false, loc = loc) as Double
        wrapAsRuntimeValue(typedReceiver.stut(times = times, delay = delay, decay = decay, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "echoWith",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "echoWith", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "echoWith", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "echoWith", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "echoWith", args = args, index = 2, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.echoWith(times = times, delay = delay, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "echoWith",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "echoWith", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "echoWith", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "echoWith", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "echoWith", args = args, index = 2, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.echoWith(times = times, delay = delay, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "stutWith",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "stutWith", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "stutWith", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "stutWith", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "stutWith", args = args, index = 2, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.stutWith(times = times, delay = delay, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "stutWith",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "stutWith", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "stutWith", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "stutWith", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "stutWith", args = args, index = 2, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.stutWith(times = times, delay = delay, transform = transform, callInfo = callInfo))
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangStructuralChunk3() {

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "stutwith",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "stutwith", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "stutwith", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "stutwith", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "stutwith", args = args, index = 2, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.stutwith(times = times, delay = delay, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "stutwith",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "stutwith", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "stutwith", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "stutwith", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "stutwith", args = args, index = 2, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.stutwith(times = times, delay = delay, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "echowith",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "echowith", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "echowith", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "echowith", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "echowith", args = args, index = 2, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.echowith(times = times, delay = delay, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "echowith",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Int::class),
            ParamSpec(name = "delay", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "echowith", args = args, expected = 3, location = loc)
        val times = convertArgToKotlin(fn = "echowith", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        val delay = convertArgToKotlin(fn = "echowith", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "echowith", args = args, index = 2, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.echowith(times = times, delay = delay, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "iter",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "iter", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "iter", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.iter(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "iter",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "iter", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "iter", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.iter(n = n, callInfo = callInfo))
    }

    // @Function on iter
    registerFunctionWithSpecs(
        name = "iter",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "iter", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "iter", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(iter(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "iter",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "iter", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "iter", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.iter(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "iterBack",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "iterBack", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "iterBack", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.iterBack(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "iterBack",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "iterBack", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "iterBack", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.iterBack(n = n, callInfo = callInfo))
    }

    // @Function on iterBack
    registerFunctionWithSpecs(
        name = "iterBack",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "iterBack", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "iterBack", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(iterBack(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "iterBack",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "iterBack", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "iterBack", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(typedReceiver.iterBack(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "invert",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "invert", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.invert(callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "invert",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "invert", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.invert(callInfo = callInfo))
    }

    // @Function on invert
    registerFunctionWithSpecs(
        name = "invert",
        paramSpecs = emptyList(),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkNoArgs(fn = "invert", args = args, location = loc)
        wrapAsRuntimeValue(invert(callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "invert",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "invert", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.invert(callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "inv",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "inv", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.inv(callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "inv",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "inv", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.inv(callInfo = callInfo))
    }

    // @Function on inv
    registerFunctionWithSpecs(
        name = "inv",
        paramSpecs = emptyList(),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkNoArgs(fn = "inv", args = args, location = loc)
        wrapAsRuntimeValue(inv(callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "inv",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "inv", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.inv(callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "applyN",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "applyN", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "applyN", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val transform = convertArgToKotlin(fn = "applyN", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.applyN(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "applyN",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "applyN", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "applyN", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val transform = convertArgToKotlin(fn = "applyN", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.applyN(n = n, transform = transform, callInfo = callInfo))
    }

    // @Function on applyN
    registerFunctionWithSpecs(
        name = "applyN",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "applyN", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "applyN", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val transform = convertArgToKotlin(fn = "applyN", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(applyN(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "applyN",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "applyN", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "applyN", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val transform = convertArgToKotlin(fn = "applyN", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.applyN(n = n, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "pressBy",
        paramSpecs = listOf(
            ParamSpec(name = "r", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "pressBy", args = args, expected = 1, location = loc)
        val r = convertArgToKotlin(fn = "pressBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.pressBy(r = r, callInfo = callInfo))
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangStructuralChunk4() {

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "pressBy",
        paramSpecs = listOf(
            ParamSpec(name = "r", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "pressBy", args = args, expected = 1, location = loc)
        val r = convertArgToKotlin(fn = "pressBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.pressBy(r = r, callInfo = callInfo))
    }

    // @Function on pressBy
    registerFunctionWithSpecs(
        name = "pressBy",
        paramSpecs = listOf(
            ParamSpec(name = "r", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "pressBy", args = args, expected = 1, location = loc)
        val r = convertArgToKotlin(fn = "pressBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(pressBy(r = r, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "pressBy",
        paramSpecs = listOf(
            ParamSpec(name = "r", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "pressBy", args = args, expected = 1, location = loc)
        val r = convertArgToKotlin(fn = "pressBy", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.pressBy(r = r, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "press",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "press", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.press(callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "press",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "press", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.press(callInfo = callInfo))
    }

    // @Function on press
    registerFunctionWithSpecs(
        name = "press",
        paramSpecs = emptyList(),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkNoArgs(fn = "press", args = args, location = loc)
        wrapAsRuntimeValue(press(callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "press",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "press", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.press(callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "jux",
        paramSpecs = listOf(
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "jux", args = args, expected = 1, location = loc)
        val transform = convertArgToKotlin(fn = "jux", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.jux(transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "jux",
        paramSpecs = listOf(
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "jux", args = args, expected = 1, location = loc)
        val transform = convertArgToKotlin(fn = "jux", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.jux(transform = transform, callInfo = callInfo))
    }

    // @Function on jux
    registerFunctionWithSpecs(
        name = "jux",
        paramSpecs = listOf(
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "jux", args = args, expected = 1, location = loc)
        val transform = convertArgToKotlin(fn = "jux", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(jux(transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "jux",
        paramSpecs = listOf(
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "jux", args = args, expected = 1, location = loc)
        val transform = convertArgToKotlin(fn = "jux", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.jux(transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "juxBy",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "juxBy", args = args, expected = 2, location = loc)
        val amount = convertArgToKotlin(fn = "juxBy", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "juxBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.juxBy(amount = amount, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "juxBy",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "juxBy", args = args, expected = 2, location = loc)
        val amount = convertArgToKotlin(fn = "juxBy", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "juxBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.juxBy(amount = amount, transform = transform, callInfo = callInfo))
    }

    // @Function on juxBy
    registerFunctionWithSpecs(
        name = "juxBy",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "juxBy", args = args, expected = 2, location = loc)
        val amount = convertArgToKotlin(fn = "juxBy", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "juxBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(juxBy(amount = amount, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "juxBy",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "juxBy", args = args, expected = 2, location = loc)
        val amount = convertArgToKotlin(fn = "juxBy", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "juxBy", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.juxBy(amount = amount, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "off",
        paramSpecs = listOf(
            ParamSpec(name = "time", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "off", args = args, expected = 2, location = loc)
        val time = convertArgToKotlin(fn = "off", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "off", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.off(time = time, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "off",
        paramSpecs = listOf(
            ParamSpec(name = "time", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "off", args = args, expected = 2, location = loc)
        val time = convertArgToKotlin(fn = "off", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "off", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.off(time = time, transform = transform, callInfo = callInfo))
    }

    // @Function on off
    registerFunctionWithSpecs(
        name = "off",
        paramSpecs = listOf(
            ParamSpec(name = "time", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "off", args = args, expected = 2, location = loc)
        val time = convertArgToKotlin(fn = "off", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "off", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(off(time = time, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "off",
        paramSpecs = listOf(
            ParamSpec(name = "time", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "off", args = args, expected = 2, location = loc)
        val time = convertArgToKotlin(fn = "off", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "off", args = args, index = 1, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.off(time = time, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "superimpose",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "superimpose", args = args, index = index, cls = Function1::class, nullable = true, loc = loc)
        } as List<((SprudelPattern) -> SprudelPattern)>
        wrapAsRuntimeValue(typedReceiver.superimpose(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "superimpose",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "superimpose", args = args, index = index, cls = Function1::class, nullable = true, loc = loc)
        } as List<((SprudelPattern) -> SprudelPattern)>
        wrapAsRuntimeValue(typedReceiver.superimpose(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on superimpose
    registerVarargFunctionWithCallInfo<((SprudelPattern) -> SprudelPattern), ((SprudelPattern) -> SprudelPattern)>("superimpose") { args, callInfo -> superimpose(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "superimpose",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "superimpose", args = args, index = index, cls = Function1::class, nullable = true, loc = loc)
        } as List<((SprudelPattern) -> SprudelPattern)>
        wrapAsRuntimeValue(typedReceiver.superimpose(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "layer",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "layer", args = args, index = index, cls = Function1::class, nullable = true, loc = loc)
        } as List<((SprudelPattern) -> SprudelPattern)>
        wrapAsRuntimeValue(typedReceiver.layer(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "layer",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "layer", args = args, index = index, cls = Function1::class, nullable = true, loc = loc)
        } as List<((SprudelPattern) -> SprudelPattern)>
        wrapAsRuntimeValue(typedReceiver.layer(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on layer
    registerVarargFunctionWithCallInfo<((SprudelPattern) -> SprudelPattern), ((SprudelPattern) -> SprudelPattern)>("layer") { args, callInfo -> layer(*args.toTypedArray(), callInfo = callInfo) }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangStructuralChunk5() {

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "layer",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "layer", args = args, index = index, cls = Function1::class, nullable = true, loc = loc)
        } as List<((SprudelPattern) -> SprudelPattern)>
        wrapAsRuntimeValue(typedReceiver.layer(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "apply",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "apply", args = args, index = index, cls = Function1::class, nullable = true, loc = loc)
        } as List<((SprudelPattern) -> SprudelPattern)>
        wrapAsRuntimeValue(typedReceiver.apply(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "apply",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "apply", args = args, index = index, cls = Function1::class, nullable = true, loc = loc)
        } as List<((SprudelPattern) -> SprudelPattern)>
        wrapAsRuntimeValue(typedReceiver.apply(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on apply
    registerVarargFunctionWithCallInfo<((SprudelPattern) -> SprudelPattern), ((SprudelPattern) -> SprudelPattern)>("apply") { args, callInfo -> apply(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "apply",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "apply", args = args, index = index, cls = Function1::class, nullable = true, loc = loc)
        } as List<((SprudelPattern) -> SprudelPattern)>
        wrapAsRuntimeValue(typedReceiver.apply(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "merge",
        paramSpecs = listOf(
            ParamSpec(name = "ctrl", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "merge", args = args, expected = 1, location = loc)
        val ctrl = convertArgToKotlin(fn = "merge", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.merge(ctrl = ctrl, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "merge",
        paramSpecs = listOf(
            ParamSpec(name = "ctrl", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "merge", args = args, expected = 1, location = loc)
        val ctrl = convertArgToKotlin(fn = "merge", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.merge(ctrl = ctrl, callInfo = callInfo))
    }

    // @Function on merge
    registerFunctionWithSpecs(
        name = "merge",
        paramSpecs = listOf(
            ParamSpec(name = "ctrl", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "merge", args = args, expected = 1, location = loc)
        val ctrl = convertArgToKotlin(fn = "merge", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(merge(ctrl = ctrl, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "merge",
        paramSpecs = listOf(
            ParamSpec(name = "ctrl", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "merge", args = args, expected = 1, location = loc)
        val ctrl = convertArgToKotlin(fn = "merge", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.merge(ctrl = ctrl, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "struct",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "struct", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.struct(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "struct",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "struct", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.struct(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on struct
    registerVarargFunctionWithCallInfo<Any, ((SprudelPattern) -> SprudelPattern)>("struct") { args, callInfo -> struct(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "struct",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "struct", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.struct(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "structAll",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "structAll", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.structAll(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "structAll",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "structAll", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.structAll(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on structAll
    registerVarargFunctionWithCallInfo<Any, ((SprudelPattern) -> SprudelPattern)>("structAll") { args, callInfo -> structAll(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "structAll",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "structAll", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.structAll(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "mask",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "mask", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.mask(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "mask",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "mask", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.mask(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on mask
    registerVarargFunctionWithCallInfo<Any, ((SprudelPattern) -> SprudelPattern)>("mask") { args, callInfo -> mask(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "mask",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "mask", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.mask(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "maskAll",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "maskAll", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.maskAll(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "maskAll",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "maskAll", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.maskAll(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on maskAll
    registerVarargFunctionWithCallInfo<Any, ((SprudelPattern) -> SprudelPattern)>("maskAll") { args, callInfo -> maskAll(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "maskAll",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "maskAll", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.maskAll(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "filterWhen",
        paramSpecs = listOf(
            ParamSpec(name = "predicate", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "filterWhen", args = args, expected = 1, location = loc)
        val predicate = convertArgToKotlin(fn = "filterWhen", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((Double) -> Boolean)
        wrapAsRuntimeValue(typedReceiver.filterWhen(predicate = predicate, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "filterWhen",
        paramSpecs = listOf(
            ParamSpec(name = "predicate", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "filterWhen", args = args, expected = 1, location = loc)
        val predicate = convertArgToKotlin(fn = "filterWhen", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((Double) -> Boolean)
        wrapAsRuntimeValue(typedReceiver.filterWhen(predicate = predicate, callInfo = callInfo))
    }

    // @Function on filterWhen
    registerFunctionWithSpecs(
        name = "filterWhen",
        paramSpecs = listOf(
            ParamSpec(name = "predicate", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "filterWhen", args = args, expected = 1, location = loc)
        val predicate = convertArgToKotlin(fn = "filterWhen", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((Double) -> Boolean)
        wrapAsRuntimeValue(filterWhen(predicate = predicate, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "filterWhen",
        paramSpecs = listOf(
            ParamSpec(name = "predicate", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "filterWhen", args = args, expected = 1, location = loc)
        val predicate = convertArgToKotlin(fn = "filterWhen", args = args, index = 0, cls = Function1::class, nullable = false, loc = loc) as ((Double) -> Boolean)
        wrapAsRuntimeValue(typedReceiver.filterWhen(predicate = predicate, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "hush",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "hush", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.hush(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangStructuralChunk6() {

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "hush",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "hush", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.hush(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on hush
    registerVarargFunctionWithCallInfo<Any, ((SprudelPattern) -> SprudelPattern)>("hush") { args, callInfo -> hush(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "hush",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "hush", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.hush(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "bypass",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "bypass", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.bypass(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "bypass",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "bypass", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.bypass(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on bypass
    registerVarargFunctionWithCallInfo<Any, ((SprudelPattern) -> SprudelPattern)>("bypass") { args, callInfo -> bypass(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "bypass",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "bypass", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.bypass(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "mute",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "mute", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.mute(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "mute",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "mute", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.mute(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on mute
    registerVarargFunctionWithCallInfo<Any, ((SprudelPattern) -> SprudelPattern)>("mute") { args, callInfo -> mute(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "mute",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "mute", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.mute(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "solo",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "solo", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.solo(
                amount = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "solo",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "solo", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.solo(
                amount = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @Function on solo
    registerFunctionWithSpecs(
        name = "solo",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "solo", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            solo(
                amount = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "solo",
        paramSpecs = listOf(
            ParamSpec(name = "amount", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "solo", args = args, expected = 0, location = loc)
        wrapAsRuntimeValue(
            typedReceiver.solo(
                amount = optArg(args, 0, Any::class, loc),
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "repeatCycles",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "repeatCycles", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "repeatCycles", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.repeatCycles(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "repeatCycles",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "repeatCycles", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "repeatCycles", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.repeatCycles(n = n, callInfo = callInfo))
    }

    // @Function on repeatCycles
    registerFunctionWithSpecs(
        name = "repeatCycles",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "repeatCycles", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "repeatCycles", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(repeatCycles(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "repeatCycles",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "repeatCycles", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "repeatCycles", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.repeatCycles(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "extend",
        paramSpecs = listOf(
            ParamSpec(name = "factor", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "extend", args = args, expected = 1, location = loc)
        val factor = convertArgToKotlin(fn = "extend", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.extend(factor = factor, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "extend",
        paramSpecs = listOf(
            ParamSpec(name = "factor", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "extend", args = args, expected = 1, location = loc)
        val factor = convertArgToKotlin(fn = "extend", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.extend(factor = factor, callInfo = callInfo))
    }

    // @Function on extend
    registerFunctionWithSpecs(
        name = "extend",
        paramSpecs = listOf(
            ParamSpec(name = "factor", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "extend", args = args, expected = 1, location = loc)
        val factor = convertArgToKotlin(fn = "extend", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(extend(factor = factor, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "extend",
        paramSpecs = listOf(
            ParamSpec(name = "factor", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "extend", args = args, expected = 1, location = loc)
        val factor = convertArgToKotlin(fn = "extend", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.extend(factor = factor, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "timeLoop",
        paramSpecs = listOf(
            ParamSpec(name = "duration", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "timeLoop", args = args, expected = 1, location = loc)
        val duration = convertArgToKotlin(fn = "timeLoop", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.timeLoop(duration = duration, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "timeLoop",
        paramSpecs = listOf(
            ParamSpec(name = "duration", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "timeLoop", args = args, expected = 1, location = loc)
        val duration = convertArgToKotlin(fn = "timeLoop", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.timeLoop(duration = duration, callInfo = callInfo))
    }

    // @Function on timeLoop
    registerFunctionWithSpecs(
        name = "timeLoop",
        paramSpecs = listOf(
            ParamSpec(name = "duration", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "timeLoop", args = args, expected = 1, location = loc)
        val duration = convertArgToKotlin(fn = "timeLoop", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(timeLoop(duration = duration, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "timeLoop",
        paramSpecs = listOf(
            ParamSpec(name = "duration", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "timeLoop", args = args, expected = 1, location = loc)
        val duration = convertArgToKotlin(fn = "timeLoop", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.timeLoop(duration = duration, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "repeat",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "repeat", args = args, expected = 1, location = loc)
        val times = convertArgToKotlin(fn = "repeat", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.repeat(times = times, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "repeat",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "repeat", args = args, expected = 1, location = loc)
        val times = convertArgToKotlin(fn = "repeat", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.repeat(times = times, callInfo = callInfo))
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangStructuralChunk7() {

    // @Function on repeat
    registerFunctionWithSpecs(
        name = "repeat",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "repeat", args = args, expected = 1, location = loc)
        val times = convertArgToKotlin(fn = "repeat", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(repeat(times = times, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "repeat",
        paramSpecs = listOf(
            ParamSpec(name = "times", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "repeat", args = args, expected = 1, location = loc)
        val times = convertArgToKotlin(fn = "repeat", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.repeat(times = times, callInfo = callInfo))
    }

    // @Function on seq
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("seq") { args, callInfo -> seq(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "seq",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "seq", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.seq(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "seq",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "seq", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.seq(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on stack
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("stack") { args, callInfo -> stack(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "stack",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "stack", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.stack(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "stack",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "stack", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.stack(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on arrange
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("arrange") { args, callInfo -> arrange(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "arrange",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "arrange", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.arrange(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "arrange",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "arrange", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.arrange(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on stackBy
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("stackBy") { args, callInfo -> stackBy(*args.toTypedArray(), callInfo = callInfo) }

    // @Function on stackLeft
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("stackLeft") { args, callInfo -> stackLeft(*args.toTypedArray(), callInfo = callInfo) }

    // @Function on stackRight
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("stackRight") { args, callInfo -> stackRight(*args.toTypedArray(), callInfo = callInfo) }

    // @Function on stackCentre
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("stackCentre") { args, callInfo -> stackCentre(*args.toTypedArray(), callInfo = callInfo) }

    // @Function on sequenceP
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("sequenceP") { args, callInfo -> sequenceP(*args.toTypedArray(), callInfo = callInfo) }

    // @Property on silence
    registerObject("silence", silence)

    // @Property on rest
    registerObject("rest", rest)

    // @Property on nothing
    registerObject("nothing", nothing)

    // @Function on gap
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("gap") { args, callInfo -> gap(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "gap",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "gap", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.gap(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "gap",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        val kotlinArgs = List(args.size) { index ->
            convertArgToKotlin(fn = "gap", args = args, index = index, cls = Any::class, nullable = true, loc = loc)
        } as List<Any>
        wrapAsRuntimeValue(typedReceiver.gap(*kotlinArgs.toTypedArray(), callInfo = callInfo))
    }

    // @Function on mini
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("mini") { args, callInfo -> mini(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "mini",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "mini", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.mini(callInfo = callInfo))
    }

    // @Function on pure
    registerFunctionWithSpecs(
        name = "pure",
        paramSpecs = listOf(
            ParamSpec(name = "value", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "pure", args = args, expected = 1, location = loc)
        val value = convertArgToKotlin(fn = "pure", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(pure(value = value, callInfo = callInfo))
    }

    // @Function on run
    registerFunctionWithSpecs(
        name = "run",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "run", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "run", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(run(n = n, callInfo = callInfo))
    }

    // @Function on binaryN
    registerFunctionWithSpecs(
        name = "binaryN",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "bits", kotlinType = Int::class, isOptional = true, default = { wrapAsRuntimeValue(16) })
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "binaryN", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "binaryN", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            binaryN(
                n = n,
                bits = if (args.size > 1) convertArgToKotlin(fn = "binaryN", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int else 16,
                callInfo = callInfo,
            )
        )
    }

    // @Function on binary
    registerFunctionWithSpecs(
        name = "binary",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "binary", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "binary", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(binary(n = n, callInfo = callInfo))
    }

    // @Function on binaryNL
    registerFunctionWithSpecs(
        name = "binaryNL",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class),
            ParamSpec(name = "bits", kotlinType = Int::class, isOptional = true, default = { wrapAsRuntimeValue(16) })
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "binaryNL", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "binaryNL", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(
            binaryNL(
                n = n,
                bits = if (args.size > 1) convertArgToKotlin(fn = "binaryNL", args = args, index = 1, cls = Int::class, nullable = false, loc = loc) as Int else 16,
                callInfo = callInfo,
            )
        )
    }

    // @Function on binaryL
    registerFunctionWithSpecs(
        name = "binaryL",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Int::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "binaryL", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "binaryL", args = args, index = 0, cls = Int::class, nullable = false, loc = loc) as Int
        wrapAsRuntimeValue(binaryL(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "morse",
        paramSpecs = listOf(
            ParamSpec(name = "text", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "morse", args = args, expected = 1, location = loc)
        val text = convertArgToKotlin(fn = "morse", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.morse(text = text, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "morse",
        paramSpecs = listOf(
            ParamSpec(name = "text", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "morse", args = args, expected = 1, location = loc)
        val text = convertArgToKotlin(fn = "morse", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.morse(text = text, callInfo = callInfo))
    }

    // @Function on morse
    registerFunctionWithSpecs(
        name = "morse",
        paramSpecs = listOf(
            ParamSpec(name = "text", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "morse", args = args, expected = 1, location = loc)
        val text = convertArgToKotlin(fn = "morse", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(morse(text = text, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "segment",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "segment", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "segment", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.segment(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "segment",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "segment", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "segment", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.segment(n = n, callInfo = callInfo))
    }

    // @Function on segment
    registerFunctionWithSpecs(
        name = "segment",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "segment", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "segment", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(segment(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "segment",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "segment", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "segment", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.segment(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "seg",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "seg", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "seg", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.seg(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "seg",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "seg", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "seg", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.seg(n = n, callInfo = callInfo))
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangStructuralChunk8() {

    // @Function on seg
    registerFunctionWithSpecs(
        name = "seg",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "seg", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "seg", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(seg(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "seg",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "seg", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "seg", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.seg(n = n, callInfo = callInfo))
    }

    // @Function on ratio
    registerVarargFunctionWithCallInfo<Any, SprudelPattern>("ratio") { args, callInfo -> ratio(*args.toTypedArray(), callInfo = callInfo) }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "ratio",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "ratio", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.ratio(callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "ratio",
        paramSpecs = emptyList(),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkNoArgs(fn = "ratio", args = args, location = loc)
        wrapAsRuntimeValue(typedReceiver.ratio(callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "pace",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "pace", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "pace", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.pace(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "pace",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "pace", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "pace", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.pace(n = n, callInfo = callInfo))
    }

    // @Function on pace
    registerFunctionWithSpecs(
        name = "pace",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "pace", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "pace", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(pace(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "pace",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "pace", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "pace", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.pace(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "steps",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "steps", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "steps", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.steps(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "steps",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "steps", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "steps", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.steps(n = n, callInfo = callInfo))
    }

    // @Function on steps
    registerFunctionWithSpecs(
        name = "steps",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "steps", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "steps", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(steps(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "steps",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "steps", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "steps", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.steps(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "take",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "take", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "take", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.take(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "take",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "take", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "take", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.take(n = n, callInfo = callInfo))
    }

    // @Function on take
    registerFunctionWithSpecs(
        name = "take",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "take", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "take", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(take(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "take",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "take", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "take", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.take(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "drop",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "drop", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "drop", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.drop(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "drop",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "drop", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "drop", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.drop(n = n, callInfo = callInfo))
    }

    // @Function on drop
    registerFunctionWithSpecs(
        name = "drop",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "drop", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "drop", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(drop(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "drop",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "drop", args = args, expected = 1, location = loc)
        val n = convertArgToKotlin(fn = "drop", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.drop(n = n, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "tag",
        paramSpecs = listOf(
            ParamSpec(name = "name", kotlinType = String::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "tag", args = args, expected = 1, location = loc)
        val name = convertArgToKotlin(fn = "tag", args = args, index = 0, cls = String::class, nullable = false, loc = loc) as String
        wrapAsRuntimeValue(typedReceiver.tag(name = name, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "tag",
        paramSpecs = listOf(
            ParamSpec(name = "name", kotlinType = String::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "tag", args = args, expected = 1, location = loc)
        val name = convertArgToKotlin(fn = "tag", args = args, index = 0, cls = String::class, nullable = false, loc = loc) as String
        wrapAsRuntimeValue(typedReceiver.tag(name = name, callInfo = callInfo))
    }

    // @Function on tag
    registerFunctionWithSpecs(
        name = "tag",
        paramSpecs = listOf(
            ParamSpec(name = "name", kotlinType = String::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "tag", args = args, expected = 1, location = loc)
        val name = convertArgToKotlin(fn = "tag", args = args, index = 0, cls = String::class, nullable = false, loc = loc) as String
        wrapAsRuntimeValue(tag(name = name, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "tag",
        paramSpecs = listOf(
            ParamSpec(name = "name", kotlinType = String::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "tag", args = args, expected = 1, location = loc)
        val name = convertArgToKotlin(fn = "tag", args = args, index = 0, cls = String::class, nullable = false, loc = loc) as String
        wrapAsRuntimeValue(typedReceiver.tag(name = name, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "tweak",
        paramSpecs = listOf(
            ParamSpec(name = "name", kotlinType = String::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "tweak", args = args, expected = 1, location = loc)
        val name = convertArgToKotlin(fn = "tweak", args = args, index = 0, cls = String::class, nullable = false, loc = loc) as String
        wrapAsRuntimeValue(typedReceiver.tweak(name = name, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "tweak",
        paramSpecs = listOf(
            ParamSpec(name = "name", kotlinType = String::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "tweak", args = args, expected = 1, location = loc)
        val name = convertArgToKotlin(fn = "tweak", args = args, index = 0, cls = String::class, nullable = false, loc = loc) as String
        wrapAsRuntimeValue(typedReceiver.tweak(name = name, callInfo = callInfo))
    }

    // @Function on tweak
    registerFunctionWithSpecs(
        name = "tweak",
        paramSpecs = listOf(
            ParamSpec(name = "name", kotlinType = String::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "tweak", args = args, expected = 1, location = loc)
        val name = convertArgToKotlin(fn = "tweak", args = args, index = 0, cls = String::class, nullable = false, loc = loc) as String
        wrapAsRuntimeValue(tweak(name = name, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "tweak",
        paramSpecs = listOf(
            ParamSpec(name = "name", kotlinType = String::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "tweak", args = args, expected = 1, location = loc)
        val name = convertArgToKotlin(fn = "tweak", args = args, index = 0, cls = String::class, nullable = false, loc = loc) as String
        wrapAsRuntimeValue(typedReceiver.tweak(name = name, callInfo = callInfo))
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangStructuralChunk9() {

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "tweaks",
        paramSpecs = listOf(
            ParamSpec(name = "defs", kotlinType = ObjectValue::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "tweaks", args = args, expected = 1, location = loc)
        val defs = convertArgToKotlin(fn = "tweaks", args = args, index = 0, cls = ObjectValue::class, nullable = false, loc = loc) as ObjectValue
        wrapAsRuntimeValue(typedReceiver.tweaks(defs = defs, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "tweaks",
        paramSpecs = listOf(
            ParamSpec(name = "defs", kotlinType = ObjectValue::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "tweaks", args = args, expected = 1, location = loc)
        val defs = convertArgToKotlin(fn = "tweaks", args = args, index = 0, cls = ObjectValue::class, nullable = false, loc = loc) as ObjectValue
        wrapAsRuntimeValue(typedReceiver.tweaks(defs = defs, callInfo = callInfo))
    }

    // @Function on tweaks
    registerFunctionWithSpecs(
        name = "tweaks",
        paramSpecs = listOf(
            ParamSpec(name = "defs", kotlinType = ObjectValue::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "tweaks", args = args, expected = 1, location = loc)
        val defs = convertArgToKotlin(fn = "tweaks", args = args, index = 0, cls = ObjectValue::class, nullable = false, loc = loc) as ObjectValue
        wrapAsRuntimeValue(tweaks(defs = defs, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "tweaks",
        paramSpecs = listOf(
            ParamSpec(name = "defs", kotlinType = ObjectValue::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "tweaks", args = args, expected = 1, location = loc)
        val defs = convertArgToKotlin(fn = "tweaks", args = args, index = 0, cls = ObjectValue::class, nullable = false, loc = loc) as ObjectValue
        wrapAsRuntimeValue(typedReceiver.tweaks(defs = defs, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "zoom",
        paramSpecs = listOf(
            ParamSpec(name = "start", kotlinType = Any::class),
            ParamSpec(name = "end", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "zoom", args = args, expected = 2, location = loc)
        val start = convertArgToKotlin(fn = "zoom", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val end = convertArgToKotlin(fn = "zoom", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.zoom(start = start, end = end, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "zoom",
        paramSpecs = listOf(
            ParamSpec(name = "start", kotlinType = Any::class),
            ParamSpec(name = "end", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "zoom", args = args, expected = 2, location = loc)
        val start = convertArgToKotlin(fn = "zoom", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val end = convertArgToKotlin(fn = "zoom", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.zoom(start = start, end = end, callInfo = callInfo))
    }

    // @Function on zoom
    registerFunctionWithSpecs(
        name = "zoom",
        paramSpecs = listOf(
            ParamSpec(name = "start", kotlinType = Any::class),
            ParamSpec(name = "end", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "zoom", args = args, expected = 2, location = loc)
        val start = convertArgToKotlin(fn = "zoom", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val end = convertArgToKotlin(fn = "zoom", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(zoom(start = start, end = end, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "zoom",
        paramSpecs = listOf(
            ParamSpec(name = "start", kotlinType = Any::class),
            ParamSpec(name = "end", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "zoom", args = args, expected = 2, location = loc)
        val start = convertArgToKotlin(fn = "zoom", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val end = convertArgToKotlin(fn = "zoom", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.zoom(start = start, end = end, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "within",
        paramSpecs = listOf(
            ParamSpec(name = "start", kotlinType = Double::class),
            ParamSpec(name = "end", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "within", args = args, expected = 3, location = loc)
        val start = convertArgToKotlin(fn = "within", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        val end = convertArgToKotlin(fn = "within", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "within", args = args, index = 2, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.within(start = start, end = end, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "within",
        paramSpecs = listOf(
            ParamSpec(name = "start", kotlinType = Double::class),
            ParamSpec(name = "end", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "within", args = args, expected = 3, location = loc)
        val start = convertArgToKotlin(fn = "within", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        val end = convertArgToKotlin(fn = "within", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "within", args = args, index = 2, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.within(start = start, end = end, transform = transform, callInfo = callInfo))
    }

    // @Function on within
    registerFunctionWithSpecs(
        name = "within",
        paramSpecs = listOf(
            ParamSpec(name = "start", kotlinType = Double::class),
            ParamSpec(name = "end", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "within", args = args, expected = 3, location = loc)
        val start = convertArgToKotlin(fn = "within", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        val end = convertArgToKotlin(fn = "within", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "within", args = args, index = 2, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(within(start = start, end = end, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "within",
        paramSpecs = listOf(
            ParamSpec(name = "start", kotlinType = Double::class),
            ParamSpec(name = "end", kotlinType = Double::class),
            ParamSpec(name = "transform", kotlinType = Function1::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "within", args = args, expected = 3, location = loc)
        val start = convertArgToKotlin(fn = "within", args = args, index = 0, cls = Double::class, nullable = false, loc = loc) as Double
        val end = convertArgToKotlin(fn = "within", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
        val transform = convertArgToKotlin(fn = "within", args = args, index = 2, cls = Function1::class, nullable = false, loc = loc) as ((SprudelPattern) -> SprudelPattern)
        wrapAsRuntimeValue(typedReceiver.within(start = start, end = end, transform = transform, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "linger",
        paramSpecs = listOf(
            ParamSpec(name = "t", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "linger", args = args, expected = 1, location = loc)
        val t = convertArgToKotlin(fn = "linger", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.linger(t = t, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "linger",
        paramSpecs = listOf(
            ParamSpec(name = "t", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "linger", args = args, expected = 1, location = loc)
        val t = convertArgToKotlin(fn = "linger", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.linger(t = t, callInfo = callInfo))
    }

    // @Function on linger
    registerFunctionWithSpecs(
        name = "linger",
        paramSpecs = listOf(
            ParamSpec(name = "t", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "linger", args = args, expected = 1, location = loc)
        val t = convertArgToKotlin(fn = "linger", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(linger(t = t, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "linger",
        paramSpecs = listOf(
            ParamSpec(name = "t", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "linger", args = args, expected = 1, location = loc)
        val t = convertArgToKotlin(fn = "linger", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.linger(t = t, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "bite",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class),
            ParamSpec(name = "indices", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bite", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "bite", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val indices = convertArgToKotlin(fn = "bite", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.bite(n = n, indices = indices, callInfo = callInfo))
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "bite",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class),
            ParamSpec(name = "indices", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bite", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "bite", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val indices = convertArgToKotlin(fn = "bite", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.bite(n = n, indices = indices, callInfo = callInfo))
    }

    // @Function on bite
    registerFunctionWithSpecs(
        name = "bite",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class),
            ParamSpec(name = "indices", kotlinType = Any::class)
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "bite", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "bite", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val indices = convertArgToKotlin(fn = "bite", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(bite(n = n, indices = indices, callInfo = callInfo))
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "bite",
        paramSpecs = listOf(
            ParamSpec(name = "n", kotlinType = Any::class),
            ParamSpec(name = "indices", kotlinType = Any::class)
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "bite", args = args, expected = 2, location = loc)
        val n = convertArgToKotlin(fn = "bite", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        val indices = convertArgToKotlin(fn = "bite", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(typedReceiver.bite(n = n, indices = indices, callInfo = callInfo))
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "ribbon",
        paramSpecs = listOf(
            ParamSpec(name = "offset", kotlinType = Any::class),
            ParamSpec(name = "cycles", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "ribbon", args = args, expected = 1, location = loc)
        val offset = convertArgToKotlin(fn = "ribbon", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.ribbon(
                offset = offset,
                cycles = if (args.size > 1) convertArgToKotlin(fn = "ribbon", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                callInfo = callInfo,
            )
        )
    }
}

internal fun KlangScriptExtensionBuilder.registerSprudelLangStructuralChunk10() {

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "ribbon",
        paramSpecs = listOf(
            ParamSpec(name = "offset", kotlinType = Any::class),
            ParamSpec(name = "cycles", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "ribbon", args = args, expected = 1, location = loc)
        val offset = convertArgToKotlin(fn = "ribbon", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.ribbon(
                offset = offset,
                cycles = if (args.size > 1) convertArgToKotlin(fn = "ribbon", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                callInfo = callInfo,
            )
        )
    }

    // @Function on ribbon
    registerFunctionWithSpecs(
        name = "ribbon",
        paramSpecs = listOf(
            ParamSpec(name = "offset", kotlinType = Any::class),
            ParamSpec(name = "cycles", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "ribbon", args = args, expected = 1, location = loc)
        val offset = convertArgToKotlin(fn = "ribbon", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            ribbon(
                offset = offset,
                cycles = if (args.size > 1) convertArgToKotlin(fn = "ribbon", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "ribbon",
        paramSpecs = listOf(
            ParamSpec(name = "offset", kotlinType = Any::class),
            ParamSpec(name = "cycles", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "ribbon", args = args, expected = 1, location = loc)
        val offset = convertArgToKotlin(fn = "ribbon", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.ribbon(
                offset = offset,
                cycles = if (args.size > 1) convertArgToKotlin(fn = "ribbon", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(SprudelPattern::class) on SprudelPattern
    registerExtensionMethodWithSpecs(
        receiver = SprudelPattern::class,
        name = "rib",
        paramSpecs = listOf(
            ParamSpec(name = "offset", kotlinType = Any::class),
            ParamSpec(name = "cycles", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(SprudelPattern::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "rib", args = args, expected = 1, location = loc)
        val offset = convertArgToKotlin(fn = "rib", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.rib(
                offset = offset,
                cycles = if (args.size > 1) convertArgToKotlin(fn = "rib", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(StringValue::class) on StringValue
    registerExtensionMethodWithSpecs(
        receiver = StringValue::class,
        name = "rib",
        paramSpecs = listOf(
            ParamSpec(name = "offset", kotlinType = Any::class),
            ParamSpec(name = "cycles", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(String::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "rib", args = args, expected = 1, location = loc)
        val offset = convertArgToKotlin(fn = "rib", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.rib(
                offset = offset,
                cycles = if (args.size > 1) convertArgToKotlin(fn = "rib", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                callInfo = callInfo,
            )
        )
    }

    // @Function on rib
    registerFunctionWithSpecs(
        name = "rib",
        paramSpecs = listOf(
            ParamSpec(name = "offset", kotlinType = Any::class),
            ParamSpec(name = "cycles", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { args, loc ->
        val callInfo = callInfoOf(null, args, loc)
        checkArgsSize(fn = "rib", args = args, expected = 1, location = loc)
        val offset = convertArgToKotlin(fn = "rib", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            rib(
                offset = offset,
                cycles = if (args.size > 1) convertArgToKotlin(fn = "rib", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                callInfo = callInfo,
            )
        )
    }

    // @TypeExtensions(Function1::class) on Function1
    registerExtensionMethodWithSpecs(
        receiver = Function1::class,
        name = "rib",
        paramSpecs = listOf(
            ParamSpec(name = "offset", kotlinType = Any::class),
            ParamSpec(name = "cycles", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) })
        ),
    ) { receiver, args, loc ->
        @Suppress("UNCHECKED_CAST")
        val typedReceiver = wrapAsRuntimeValue(receiver).convertToKotlin(PatternMapperFn::class, loc)
        val callInfo = callInfoOf(receiver, args, loc)
        checkArgsSize(fn = "rib", args = args, expected = 1, location = loc)
        val offset = convertArgToKotlin(fn = "rib", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any
        wrapAsRuntimeValue(
            typedReceiver.rib(
                offset = offset,
                cycles = if (args.size > 1) convertArgToKotlin(fn = "rib", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                callInfo = callInfo,
            )
        )
    }
}

